import React from "react";
import "./DayChipSelector.css";

const DAYS = [
  { key: "MON", label: "Mon" },
  { key: "TUE", label: "Tue" },
  { key: "WED", label: "Wed" },
  { key: "THU", label: "Thu" },
  { key: "FRI", label: "Fri" },
  { key: "SAT", label: "Sat" },
  { key: "SUN", label: "Sun" },
];

export default function DayChipSelector({
  selectedDays = [],
  onChange,
  label,
  helperText,
  readOnly = false,
  mode = "workdays",
}) {
  const handleToggle = (dayKey) => {
    if (readOnly) return;
    const isSelected = selectedDays.includes(dayKey);
    if (isSelected) {
      onChange(selectedDays.filter((d) => d !== dayKey));
    } else {
      onChange([...selectedDays, dayKey]);
    }
  };

  const summaryText =
    mode === "daysoff"
      ? `${selectedDays.length} day${selectedDays.length !== 1 ? "s" : ""} off selected`
      : `${selectedDays.length} working day${selectedDays.length !== 1 ? "s" : ""} selected`;

  return (
    <div className="day-chip-selector">
      {label && <label className="field-label">{label}</label>}
      {helperText && <p className="helper-text">{helperText}</p>}
      <div className="chips-row">
        {DAYS.map((day) => {
          const isSelected = selectedDays.includes(day.key);
          return (
            <button
              key={day.key}
              type="button"
              role="checkbox"
              aria-checked={isSelected}
              aria-label={`${day.label} ${isSelected ? "selected" : "not selected"}`}
              onClick={() => handleToggle(day.key)}
              className={[
                "day-chip",
                isSelected ? "selected" : "",
                readOnly ? "read-only" : "",
              ]
                .join(" ")
                .trim()}
            >
              {day.label}
              {isSelected && <span className="chip-check">✓</span>}
            </button>
          );
        })}
      </div>
      <p className="chips-summary">{summaryText}</p>
    </div>
  );
}
